module.exports = __webpack_public_path__ + "static/media/semiology-specific.762ee16f.svg";